/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 *     - `wle:auto-constants:start` and `wle:auto-constants:end`: The project's constants,
 *        such as the project's name, whether it should use the physx runtime, etc...
 *     - `wle:auto-benchmark:start` and `wle:auto-benchmark:end`: Append the benchmarking code
 */

/* wle:auto-imports:start */
import {AudioListener} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {FingerCursor} from '@wonderlandengine/components';
import {HandTracking} from '@wonderlandengine/components';
import {HowlerAudioListener} from '@wonderlandengine/components';
import {InputProfile as InputProfile1} from './input-profile.js';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {TeleportComponent} from '@wonderlandengine/components';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {VirtualKeyboardUIRootComponent} from 'lazy-widgets-wle';
import {ThreeDcursorGrabBridge} from './ 3dcursor-grab-bridge.js';
import {IntifaceController} from './IntifaceController.js';
import {NotificationTextPositioner} from './NotificationTextPositioner.js';
import {AvatarController} from './avatar/avatar-controller.js';
import {CopyCoordinate} from './copy-rotation.js';
import {CopyHeadNod} from './copy-rotation.js';
import {CopyRotation} from './copy-rotation.js';
import {DeactivateOnStart} from './deactivate-on-start.js';
import {OscillatingRot} from './etoy/oscillating-rot.js';
import {Prosthetic} from './etoy/prosthetic.js';
import {ProximityVibe} from './etoy/proximity-vibe.js';
import {EventsClient} from './events-client.js';
import {Fullscreen} from './fullscreen.js';
import {JoystickPhysxMotion} from './joystick-physx-motion.js';
import {LazyWidgetsRootCompat} from './lazy-widgets-root-compat.js';
import {LookAtPlayer} from './look-at.js';
import {MenuController} from './menus/menu-controller.js';
import {VrMenuRenderer} from './menus/renderers/VrMenuRenderer.js';
import {MobileActiveSwitch} from './mobile-active-switch.js';
import {NetworkedGrabbable} from './networked-grabbable.js';
import {NetworkListenVideoTexture} from './networklisten-video-texture.js';
import {Orchestrated} from './orchestrated.js';
import {PlayerMovementHandler} from './player-movement-handler.js';
import {SafetyReset} from './safety-reset.js';
import {SceneController} from './scene-controller.js';
import {SharedMediaVideoTexture} from './sharedmedia-video-texture.js';
import {SmoothRotate} from './smooth-rotate.js';
import {SnapRotate as SnapRotate1} from './snap-rotation.js';
import {SpeakerIndicator} from './speaker-indicator.js';
import {TouchMove} from './touch-move.js';
import {TouchUI} from './touch-ui.js';
import {VrBodyFollow} from './vr-body-follow.js';
import {WasdPhysxControlsComponent} from './wasd-physx-controls.js';
import {Grabbable} from './wle-interaction/index.js';
import {Interactable} from './wle-interaction/index.js';
import {Interactor} from './wle-interaction/index.js';
import {XRPointerDiagnostics} from './xr-pointer-diagnostics.js';
/* wle:auto-imports:end */

import {loadRuntime} from '@wonderlandengine/api';
import * as API from '@wonderlandengine/api'; // Deprecated: Backward compatibility.

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'CBGPeerVideoHaptic',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['local','local-floor','hand-tracking','hit-test',],
};
const RuntimeOptions = {
    webgl2: true,
    webgpu: false,
    physx: true,
    loader: true,
    xrFramebufferScaleFactor: 1,
    loadUncompressedImagesAsBitmap: false,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

// Keep the local origin even if editor-generated XR feature settings change.
// Apply before loadRuntime so offered sessions and button requests agree.
Constants.WebXRRequiredFeatures = ['local'];
Constants.WebXROptionalFeatures = Constants.WebXROptionalFeatures.filter(
    (feature) => feature !== 'local-floor' && feature !== 'bounded-floor'
);
RuntimeOptions.xrOfferSession.features = Constants.WebXRRequiredFeatures;
RuntimeOptions.xrOfferSession.optionalFeatures = Constants.WebXROptionalFeatures;

const engine = await loadRuntime(Constants.RuntimeBaseName, RuntimeOptions);
Object.assign(engine, API); // Deprecated: Backward compatibility.
window.WL = engine; // Deprecated: Backward compatibility.

engine.onSceneLoaded.once(() => {
    const el = document.getElementById('version');
    if (el) setTimeout(() => el.remove(), 2000);
});

/* WebXR setup. */

function requestSession(mode) {
    engine
        .requestXRSession(mode, Constants.WebXRRequiredFeatures, Constants.WebXROptionalFeatures)
        .catch((e) => console.error(e));
}

function setupButtonsXR() {
    /* Setup AR / VR buttons */
    const arButton = document.getElementById('ar-button');
    if (arButton) {
        arButton.dataset.supported = engine.arSupported;
        arButton.addEventListener('click', () => requestSession('immersive-ar'));
    }
    const vrButton = document.getElementById('vr-button');
    if (vrButton) {
        vrButton.dataset.supported = engine.vrSupported;
        vrButton.addEventListener('click', () => requestSession('immersive-vr'));
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('load', setupButtonsXR);
} else {
    setupButtonsXR();
}

/* wle:auto-register:start */
engine.registerComponent(AudioListener);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(FingerCursor);
engine.registerComponent(HandTracking);
engine.registerComponent(HowlerAudioListener);
engine.registerComponent(InputProfile1);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(TeleportComponent);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(VirtualKeyboardUIRootComponent);
engine.registerComponent(ThreeDcursorGrabBridge);
engine.registerComponent(IntifaceController);
engine.registerComponent(NotificationTextPositioner);
engine.registerComponent(AvatarController);
engine.registerComponent(CopyCoordinate);
engine.registerComponent(CopyHeadNod);
engine.registerComponent(CopyRotation);
engine.registerComponent(DeactivateOnStart);
engine.registerComponent(OscillatingRot);
engine.registerComponent(Prosthetic);
engine.registerComponent(ProximityVibe);
engine.registerComponent(EventsClient);
engine.registerComponent(Fullscreen);
engine.registerComponent(JoystickPhysxMotion);
engine.registerComponent(LazyWidgetsRootCompat);
engine.registerComponent(LookAtPlayer);
engine.registerComponent(MenuController);
engine.registerComponent(VrMenuRenderer);
engine.registerComponent(MobileActiveSwitch);
engine.registerComponent(NetworkedGrabbable);
engine.registerComponent(NetworkListenVideoTexture);
engine.registerComponent(Orchestrated);
engine.registerComponent(PlayerMovementHandler);
engine.registerComponent(SafetyReset);
engine.registerComponent(SceneController);
engine.registerComponent(SharedMediaVideoTexture);
engine.registerComponent(SmoothRotate);
engine.registerComponent(SnapRotate1);
engine.registerComponent(SpeakerIndicator);
engine.registerComponent(TouchMove);
engine.registerComponent(TouchUI);
engine.registerComponent(VrBodyFollow);
engine.registerComponent(WasdPhysxControlsComponent);
engine.registerComponent(Grabbable);
engine.registerComponent(Interactable);
engine.registerComponent(Interactor);
engine.registerComponent(XRPointerDiagnostics);
/* wle:auto-register:end */

engine.scene.load(`${Constants.ProjectName}.bin`).catch((e) => {
    console.error(e);
    window.alert(`Failed to load ${Constants.ProjectName}.bin:`, e);
});

/* wle:auto-benchmark:start */
/* wle:auto-benchmark:end */
